import React, { Component } from 'react';
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";

class PowerBiComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                {this.props.embedUrl !== undefined && this.props.embedUrl !== '' && <PowerBIEmbed
                    className="test"
                    embedConfig={
                        {
                            type: 'report', // Supported types: report, dashboard, tile, visual, and qna.
                            embedUrl: this.props.embedUrl,
                            id: this.props.PowerBIId,
                            accessToken: this.props.PowerBIToken,
                            tokenType: models.TokenType.Embed, // Use models.TokenType.Aad if you're embedding for your organization.
                            settings: {
                                panes: {
                                    filters: {
                                        expanded: false,
                                        visible: false
                                    }
                                },
                            }
                        }
                    }

                    eventHandlers={
                        new Map([
                            ['loaded', function () {
                            }],
                            ['rendered', function () {
                            }],
                            ['error', function (event) {
                            }]
                        ])
                    }

                    cssClassName={
                        "report-style-class"
                    }

                    getEmbeddedComponent={
                        (embeddedReport) => {
                            window.report = embeddedReport;
                        }
                    }>
                </PowerBIEmbed>}
            </div>
        );
    }
}

export default PowerBiComponent;